import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel2';
import MatchBanner from './MatchBanner';
import Skeleton from 'react-loading-skeleton'
import { dynamoClient } from '../../../App';
import { getFavEvents } from '../../../dynamo/favoriteParams';
import Util from '../../../helper/Util';
import { getImportantMatches, getBannerMatchMarkets } from '../../../dynamo/params';
import { MARKET_FOR_OUTER_SLIDER_PREMATCH } from '../../../config/markets';
import 'react-loading-skeleton/dist/skeleton.css';
import { intervalTime } from '../../../config';
import { connect } from 'react-redux';
import { setImpMatches } from '../../../store/actions/home.actions';
import { withRouter } from 'react-router-dom';
import LoadingIcon from '../../../Components/Common/LoadingIcon';
import Loading from '../../../Components/Common/NewLoading';

let getBannerInterval; 

const options = {
    nav: false,
    margin:10,
    dots: false,    
    //   navText: ['<div class=\'nav-btn prev-slide\'><i class="fas fa-chevron-left"></i></div>','<div class=\'nav-btn next-slide\'><i class="fas fa-chevron-right"></i></div>'],
    autoplay: true,
    stagePadding: 40,
    //   margin: 40,    
    autoplaySpeed: 2000,
    autoplayTimeout: 10000,
    loop: false,
    responsive : {
        1500 : { items : 3  // from 768 screen width to 1024 8 items
            },
        1200 : { items : 3  // from 768 screen width to 1024 8 items
            },
        1024 : { items : 2   // from 768 screen width to 1024 8 items
            }
    },
};

class BannerCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fixtureData: [],
            impMatches: [],
            loading: true,
        };
    }
    
    componentDidMount() {
        this.setState({ loading: true });
        this.getImpMatches()
        getBannerInterval = setInterval(() => { this.getImpMatches(); }, intervalTime); 
    }

    componentWillUnmount() {
        clearInterval(getBannerInterval);
    }

    getPartialData = async (fixtureArray) => {
        const eventObj = {};
        fixtureArray.map((event,i) => eventObj[`:evt${event}`] = { fixture_id: `${event}` });
        let event = dynamoClient.batchGet(getFavEvents(eventObj)).promise();
        await event.then(res => {
            let { Responses: { PartialDevent } } = res;
                if (PartialDevent?.length) {
                    PartialDevent = Util.partialMatchFormatter(PartialDevent);
                    this.setState({ fixtureData: PartialDevent });
                }
        }).catch(err => {
            if (err) {
                console.log(err);
            }
        });
    };

    getMarketData = async (fixtureArray, partialData) => {
        if (!fixtureArray?.length) {
            this.setState({loading: false});
            return null;
        }
        const eventObj = {};
        fixtureArray.map((event,i) => {
            let marketId = MARKET_FOR_OUTER_SLIDER_PREMATCH[event.sport_id]?.[0]?.Id;
            if (marketId) {
                eventObj[`:evt-${i}`] = { fixture_id: `${event.fixture_id}^${marketId}` };
            }
        });
        let partialDataObj = partialData.reduce((a, evt) => ({ ...a, [evt.fixture_id]: evt }), {});
        let event = dynamoClient.batchGet(getBannerMatchMarkets(eventObj)).promise();
        await event.then(res => {
            let { Responses: { DeventMarkets } } = res;
            if (DeventMarkets?.length) {
                DeventMarkets.map(mkt => {
                    partialDataObj[ mkt.match_id ] = { ...partialDataObj[ mkt.match_id], market: Util.marketFormatter([mkt], mkt.match_id) };
                });
                this.setState({ fixtureData: Object.values(partialDataObj), loading: false }, () => {
                    this.props.setImpMatches(this.state.fixtureData);  
                });
            }
        }).catch(err => {
            if (err) {
                this.setState({ loading: false })
                console.log(err);
            }
        });
    };

    getImpMatches= ()=>{
        const matches=[];
        let fMatches = [];
        dynamoClient.scan(getImportantMatches(), (err, data) => {
            if (err) {
                console.log('err ', err);
                this.setState({ loading: false })
            }
            else {
                if (data.Items.length > 0) {
                    fMatches = Util.partialMatchFormatter(data.Items);
                    fMatches = fMatches.filter(item => new Date(item.start_date) >= new Date());
                    fMatches.map((item) => {
                        let market = MARKET_FOR_OUTER_SLIDER_PREMATCH[item.sport_id]?.[0];
                        item.market = { [`id_${ market.Id }`]: market };
                        matches.push({ fixture_id: item.fixture_id, sport_id: item.sport_id } );
                        return item;
                    });
                    this.setState({impMatches:matches}, () => this.getMarketData(matches, fMatches));
                } else {
                    this.setState({ loading: false })
                }
            }
        });
        
    }

render() {
    const { state: { fixtureData, loading } } = this;
    const { impMatches } = this.props;
    const bannerImages = impMatches.map(item => <div ><MatchBanner item={ item }/></div>);
    return (
        <div className='carousel-parent'>
            { bannerImages.length > 0 ? 
                <div>
                    <div className="match-card-wrap imp-match">
                        <ul> 
                            <OwlCarousel
                                id='owl-demo'
                                options={ options }
                            >
                                {bannerImages}
                            </OwlCarousel>
                        </ul>
                    </div>
                </div>
            : loading ? 
                <Loading customClass='odds-panel w-100 pt-0 mx-0'/>
                // <div className='w-100 slider-content-wrap d-inline-block' style={ { position: 'relative' } }>
                //     {/* <img src='/images/match-banner.png' className='carousel-banner-img' height='160' />
                //     <div className='slider-content d-flex align-items-center'>
                //         <div className='w-100 p-3'><Skeleton count={5} /> </div>
                //     </div> */}
                // </div>
                : 
                null
                // <div className="w-100">
                //     <img className="d-block w-100" src="/images/home-banner.png" alt="First slide" />
                // </div>
            }
        </div>
    );
  }
};

const mapStateToProps = (state) => {
    return {
        impMatches: state.home.impMatches,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setImpMatches: (data) => dispatch(setImpMatches(data))
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BannerCarousel));
